// // import { useState } from 'react'
// // import { Dialog, DialogPanel } from '@headlessui/react'
// // import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'
// import Logo from '../../../assets/logo.png'
// import { Link } from 'react-router-dom'

// // const navigation = [
// //   // { name: 'Home', href: '/' },
// //   // { name: 'About', href: '/about' },
// //   // { name: 'Services', href: '/services' },
// //   // { name: 'Contact', href: '/contact' },
// //   // { name: 'Login', href: '/login' },
// //   // { name: 'Register', href: '/register' },
// // ]
// // const logreg = [
// //   { name: 'Login', href: '/login' },
// //   // { name: 'SignUp', href: '/signup' },
// // ]

// // export default function Header() {
// //   const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

// //   return (
// //     <div className="bg-white">
// //       <header className="absolute inset-x-0 top-0 z-50">
// //         <nav
// //           aria-label="Global"
// //           className="flex items-center justify-between py-12 px-6 lg:px-8"
// //         >
// //           <div className="flex lg:flex-1">
// //             <a href="#" className="-m-1.5 p-1.5">
// //               <span className="sr-only">Your Company</span>
// //               <Link to="/">
// //                 <img
// //                   alt=""
// //                   src={Logo}
// //                   className="mt-[-20px] h-[80px] w-[200px]"
// //                 />
// //               </Link>
// //             </a>
// //           </div>
// //           <div className="flex lg:hidden">
// //             <button
// //               type="button"
// //               onClick={() => setMobileMenuOpen(true)}
// //               className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
// //             >
// //               <span className="sr-only">Open main menu</span>
// //               <Bars3Icon aria-hidden="true" className="h-6 w-6" />
// //             </button>
// //           </div>
// //           <div className="hidden lg:flex lg:gap-x-12">
// //             {navigation.map((item) => (
// //               <a
// //                 key={item.name}
// //                 href={item.href}
// //                 className="text-sm font-semibold leading-6 text-gray-900"
// //               >
// //                 {item.name}
// //               </a>
// //             ))}
// //           </div>

// //           <div className="hidden lg:flex lg:flex-1 lg:justify-end lg:gap-2">
// //             <button>
// //               {logreg.map((item) => (
// //                 <a
// //                   key={item.name}
// //                   href={item.href}
// //                   className="text-sm font-semibold leading-6 text-gray-900 mr-8"
// //                 >
// //                   {item.name}
// //                 </a>
// //               ))}
// //             </button>

// //             {/* <Link
// //               to="/login"
// //               className="text-sm font-semibold leading-6 text-gray-900"
// //             >
// //               Log in <span aria-hidden="true">&rarr;</span>
// //             </Link> */}
// //           </div>
// //         </nav>
// //         <Dialog
// //           open={mobileMenuOpen}
// //           onClose={setMobileMenuOpen}
// //           className="lg:hidden"
// //         >
// //           <div className="fixed inset-0 z-50" />
// //           <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
// //             <div id="bt" className="flex items-center justify-between">
// //               <a href="#" className="-m-1.5 p-1.5">
// //                 <span className="sr-only">Your Company</span>
// //                 <img alt="" src="" className="h-8 w-auto" />
// //               </a>
// //               <button
// //                 type="button"
// //                 onClick={() => setMobileMenuOpen(false)}
// //                 className="-m-2.5 rounded-md p-2.5 text-gray-700"
// //               >
// //                 <span className="sr-only">Close menu</span>
// //                 <XMarkIcon aria-hidden="true" className="h-6 w-6" />
// //               </button>
// //             </div>
// //             <div className="mt-6 flow-root">
// //               <div className="-my-6 divide-y divide-gray-500/10">
// //                 <div className="space-y-2 py-6">
// //                   {navigation.map((item) => (
// //                     <a
// //                       key={item.name}
// //                       href={item.href}
// //                       className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
// //                     >
// //                       {item.name}
// //                     </a>
// //                   ))}
// //                 </div>
// //                 <div className="py-6">
// //                   <Link
// //                     to="/login"
// //                     className="-mx-3 block rounded-lg px-3 py-2.5 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
// //                   >
// //                     Log in
// //                   </Link>
// //                 </div>
// //               </div>
// //             </div>
// //           </DialogPanel>
// //         </Dialog>
// //       </header>
// //     </div>
// //   )
// // }

// export default function Header({ navRef }) {
//   return (
//     <nav
//       ref={navRef}
//       id="nav"
//       className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl border-b border-white/10 transition-all duration-500"
//       style={{ background: "rgba(11,31,69,.12)" }}
//     >
//       <div className="max-w-[1160px] mx-auto px-7 flex items-center justify-between h-16">
//         {/* Logo */}
//         <Link to="/" className="flex items-center gap-3">
//           <div className="w-9 h-9 rounded-md flex items-center justify-center shadow-lg">
//             {/* <div className="w-2 h-2 bg-white rounded-full" /> */}
//             <img className="w-9 h-9 bg-white rounded-full" src={Logo} alt="" />
//           </div>
//           <div>
//             <div className="text-white font-semibold text-xl tracking-tight">
//               Optiva
//             </div>
//             <div className="text-[10px] text-white/50 tracking-widest uppercase">
//               CRM Portal
//             </div>
//           </div>
//         </Link>

//         {/* Links */}
//         <div className="hidden md:flex gap-10 text-sm font-semibold text-white/70">
//           <a href="#about" className="hover:text-white transition">
//             About
//           </a>
//           <a href="#pillars" className="hover:text-white transition">
//             Vision & Mission
//           </a>
//           <a href="#contact" className="hover:text-white transition">
//             Contact
//           </a>
//         </div>

//         {/* CTA */}
//         <Link
//           to="/login"
//           className="bg-gradient-to-br from-red-600 to-red-900 text-white px-6 py-2 rounded shadow-lg hover:-translate-y-1 transition-all duration-300"
//         >
//           Client Login
//         </Link>
//       </div>
//     </nav>
//   )
// }

import { useState } from "react"
import { Link } from "react-router-dom"
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline"
import Logo from "../../../assets/logo.png"

export default function Header({ navRef }) {
  const [mobileOpen, setMobileOpen] = useState(false)

  return (
    <nav
      ref={navRef}
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl border-b border-white/10 transition-all duration-500"
      style={{ background: "rgba(11,31,69,.12)" }}
    >
      <div className="max-w-[1160px] mx-auto px-7 flex items-center justify-between h-16">
        
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-md flex items-center justify-center shadow-lg">
            <img className="w-9 h-9 bg-white rounded-full" src={Logo} alt="Logo" />
          </div>
          <div>
            <div className="text-white font-semibold text-xl tracking-tight">
              Optiva
            </div>
            <div className="text-[10px] text-white/50 tracking-widest uppercase">
              CRM Portal
            </div>
          </div>
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex gap-10 text-sm font-semibold text-white/70">
          <a href="#about" className="hover:text-white transition">
            About
          </a>
          <a href="#pillars" className="hover:text-white transition">
            Vision & Mission
          </a>
          <a href="#footer" className="hover:text-white transition">
            Contact
          </a>
        </div>

        {/* Desktop CTA */}
        <div className="hidden md:block">
          <Link
            to="/login"
            className="bg-gradient-to-br from-red-600 to-red-900 text-white px-6 py-2 rounded shadow-lg hover:-translate-y-1 transition-all duration-300"
          >
            Login
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white"
          onClick={() => setMobileOpen(true)}
        >
          <Bars3Icon className="h-7 w-7" />
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {mobileOpen && (
        <div className="fixed inset-0 bg-black/20 backdrop-blur-sm z-50 md:hidden">
          <div className="fixed top-0 right-0 h-auto w-full bg-[#0B1F45]/90 shadow-2xl flex flex-col">
            
            {/* Close Button */}
            <div className="flex justify-end mb-8 m-6">
              <button onClick={() => setMobileOpen(false)}>
                <XMarkIcon className="h-7 w-7 text-white" />
              </button>
            </div>

            {/* Mobile Links */}
            <div className="flex flex-col text-center gap-4 text-white/80 m-2 font-semibold">
              <a
                href="#about"
                onClick={() => setMobileOpen(false)}
                className="hover:text-white transition"
              >
                About
              </a>
              <a
                href="#pillars"
                onClick={() => setMobileOpen(false)}
                className="hover:text-white transition"
              >
                Vision & Mission
              </a>
              <a
                href="#footer"
                onClick={() => setMobileOpen(false)}
                className="hover:text-white transition"
              >
                Contact
              </a>

              {/* Mobile CTA */}
              <Link
                to="/login"
                onClick={() => setMobileOpen(false)}
                className="mt-6 bg-gradient-to-br from-red-600 to-red-900 text-white px-6 py-2 rounded shadow-lg text-center"
              >
                Login
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  )
}
